import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { LocalizedDatePipe } from '../../../../_pipes/localized-date.pipe';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { ModalModule } from 'ngx-bootstrap/modal';
import { WorkTimeShiftUserGroupUsersUiService } from '../../services/work-time-shift-user-group-users-ui.service';
import { WorkTimeIndicatorComponent } from './work-time-indicator.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

@NgModule({
  declarations: [
    WorkTimeIndicatorComponent,
  ],
  imports: [
    SharedModule,
    CollapseModule.forRoot(),
    PopoverModule.forRoot(),
    ScrollingModule,
    ModalModule.forRoot(),
    BsDropdownModule.forRoot(),
  ],
  exports: [
    WorkTimeIndicatorComponent,
  ],
  providers: [LocalizedDatePipe, WorkTimeShiftUserGroupUsersUiService]
})
export class WorkTimeIndicatorModule { }

